import React, { memo, useMemo } from 'react';
import { Modal, Advice, Markdown } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
const LimitsModal = /*#__PURE__*/memo(_ref => {
  let {
    isOpen,
    onConfirm,
    onCancel,
    data,
    limits
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const total = useMemo(() => {
    const newRows = (data === null || data === void 0 ? void 0 : data.rows) || 0;
    const existingRows = (limits === null || limits === void 0 ? void 0 : limits.limitUsed) || 0;
    return newRows + existingRows;
  }, [data === null || data === void 0 ? void 0 : data.rows, limits === null || limits === void 0 ? void 0 : limits.limitUsed]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    title: t('label_import_title_alert'),
    onConfirm: onConfirm,
    confirmText: t('action_accept'),
    onCancel: onCancel,
    cancelText: t('action_cancel'),
    useCornerClose: false
  }, /*#__PURE__*/React.createElement(Advice, {
    type: "warning",
    showIcon: true,
    showCollapse: false
  }, /*#__PURE__*/React.createElement(Markdown, {
    content: t('label_import_exceeding_limit_topup', [total, limits === null || limits === void 0 ? void 0 : limits.limit]),
    overrides: {
      a: {
        target: '_blank'
      }
    }
  })));
});
export default LimitsModal;